@if (errorType === 'loading') {
  <loader-overlay></loader-overlay>
}

@switch (errorType) {
  @case ('not-found') {
    <ng-container
      *ngTemplateOutlet="
        contentTemplate;
        context: {
          title: 'The Assistant does not exist',
          description: 'The Assistant has been removed and is no longer accessible.',
        }
      "
    ></ng-container>
  }
  @default {
    <ng-container
      *ngTemplateOutlet="
        contentTemplate;
        context: {
          title: 'No access',
          description: 'You don\'t have access to this Assistant. Please contact your workspace administrator for assistance.',
        }
      "
    ></ng-container>
  }
}

<ng-template #contentTemplate let-title="title" let-description="description">
  <div class="chat-assistant-header">
    <div class="title">{{ title }}</div>
  </div>
  <div class="description">{{ description }}</div>
</ng-template>

<u-button
  [label]="'Open chat'"
  type="primary"
  elementSize="medium"
  [styles]="{ width: '224px', fontSize: '14px' }"
  (onClick)="openNewChat()"
></u-button>
